import { render, staticRenderFns } from "./ProductListSwipe.vue?vue&type=template&id=6d442f3f&"
import script from "./ProductListSwipe.vue?vue&type=script&lang=js&"
export * from "./ProductListSwipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports